import {
  decreaseQuantity,
  increaseQuantity,
  removeCartItem,
} from '@/core/redux/cartSlice';
import { RootState } from '@/core/redux/store';
import { routes } from '@/utils/routes/routes';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';
import emptyCart from '../assets/images/emptycart.png';
import { TbCircleX } from 'react-icons/tb';
import { Modal } from 'react-bootstrap';

export default function Cart() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  const isLoggedIn = useSelector((state: RootState) => state.common.isLoading);

  const cartProductList =
    useSelector((state: RootState) => state.cart.cartItems) || [];

  const currencyCode = useSelector(
    (state: RootState) => state.common.header?.currency?.symbol
  );

  const currentLocation = useSelector(
    (state: RootState) => state.currentLocation.currentLocation
  );

  const calculateSubtotal = () => {
    const total = cartProductList.reduce((acc, item) => {
      const itemTotal = item.quantity * item.price;
      return acc + itemTotal;
    }, 0);

    return total.toFixed(2);
  };

  const calculateTotalAmount = () => {
    const subtotal = parseFloat(calculateSubtotal());
    
    // Apply minimum order amount if applicable
    if (minimumOrderAmount > 0 && subtotal < minimumOrderAmount) {
      return minimumOrderAmount.toFixed(2);
    }
    
    return subtotal.toFixed(2);
  };

  // Get minimum order amount from currentLocation
  const minimumOrderAmount = (currentLocation as any)?.minimum_order_amount
    ? parseFloat((currentLocation as any).minimum_order_amount)
    : 0;

  // Check if minimum order amount is met
  const isMinimumOrderMet = parseFloat(calculateSubtotal()) >= minimumOrderAmount;
  const remainingAmount = minimumOrderAmount > 0
    ? (minimumOrderAmount - parseFloat(calculateSubtotal())).toFixed(2)
    : 0;

  useEffect(() => {
    calculateTotalAmount();
  }, [cartProductList]);

  return (
    <>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-8">
            <div className="prodcat-list prodcat-list-cart table-responsive my-2 my-md-5">
              {cartProductList.length > 0 ? (
                <table className="table">
                  <tr>
                    <th></th>
                    <th>PRODUCT</th>
                    <th>PRICE</th>
                    <th className="text-center">QUANTITY</th>
                    <th>SUBTOTAL</th>
                    <th></th>
                  </tr>
                  {cartProductList?.map((item: any) => {
                    return (
                      <>
                        {item?.quantity > 0 ? (
                          <tr>
                            <td>
                              <img
                                src={item?.image}
                                title={item.name}
                                alt=""
                                className='prod-img-sm'
                              />
                            </td>
                            <td>
                              <div>
                                {item.name}
                                <br />
                                <span className="text-muted">
                                  {item.variant && item.variant !== 'regular' && item.variant !== 'express' && `(${item.variant})`}
                                </span>
                                {item.variant === 'express' && (
                                  <div className="express-wash-info text-success">
                                    <small>Express Wash Service</small>
                                  </div>
                                )}
                              </div>
                            </td>
                            <td>
                              <div className="amount">
                                <span>{parseFloat(item?.price)}</span>
                              </div>
                            </td>
                            <td className="w-25">
                              <div className="d-flex align-center justify-content-center">
                                <div className="input-qty">
                                  <button
                                    type="button"
                                    className="quantity-left-minus btn btn-number"
                                    data-type="minus"
                                    data-field=""
                                    disabled={item.quantity === '0'}
                                    onClick={() => {
                                      console.log(
                                        'decreaseQuantity : ',
                                        item?.id
                                      );
                                      dispatch(decreaseQuantity(item?.id));
                                    }}
                                  >
                                    <span className="glyphicon glyphicon-minus"></span>
                                  </button>
                                  <input
                                    placeholder=""
                                    className="form-control input-number inp-item-quantity quantity"
                                    id="quantity_1_1_1"
                                    name="quantity_1_1_1"
                                    type="text"
                                    value={item?.quantity}
                                  />
                                  <button
                                    type="button"
                                    className="quantity-right-plus btn btn-number"
                                    data-type="plus"
                                    data-field=""
                                    onClick={() =>
                                      dispatch(increaseQuantity(item?.id))
                                    }
                                  >
                                    <span className="glyphicon glyphicon-plus"></span>
                                  </button>
                                </div>
                              </div>
                            </td>
                            <td>
                              <div>
                                {currencyCode} &nbsp;
                                {(() => {
                                  const itemTotal = parseFloat(item?.price) * parseFloat(item?.quantity);
                                  return itemTotal.toFixed(2);
                                })()}
                              </div>
                            </td>
                            <td>
                              {
                                <span
                                  style={{ cursor: 'pointer', color: 'red' }}
                                  onClick={() => {
                                    dispatch(removeCartItem(item?.id));
                                    toast.success('Product removed from cart');
                                  }}
                                >
                                  <TbCircleX size={20} />
                                </span>
                              }
                            </td>
                          </tr>
                        ) : null}
                      </>
                    );
                  })}
                </table>
              ) : (
                <div className="text-center mt-5">
                  <img
                    src={emptyCart}
                    alt="Empty Cart"
                    className="empty-cart-image"
                  />
                  <h3>Your cart is empty</h3>
                  <p>Please add some products to your cart.</p>
                </div>
              )}
            </div>
          </div>
          <div className="col-md-4">
            <div className="amt-payable my-2 my-md-5">
              <div className="price-header">
                <h2>Cart summary</h2>
              </div>
              {cartProductList.length > 0 ? (
                <div className="price-body">
                  {cartProductList?.map((item: any) => {
                    return (
                      <>
                        <div className="cs-option-price">
                          <div className="cs-option-body">
                            <div className="cs-option-left">
                              <span>{item?.name} </span>
                              <span className="cs-option-pqty">
                                ({item?.quantity})
                              </span>
                            </div>
                            <div className="cs-option-right">
                              {currencyCode}
                              &nbsp;
                              {(() => {
                                const itemTotal = parseFloat(item?.quantity) * parseFloat(item?.price);
                                return itemTotal.toFixed(2);
                              })()}
                            </div>
                          </div>
                        </div>
                      </>
                    );
                  })}
                  <div className="cs-option-amt">
                    <div className="cs-option-amt-list">
                      <div className="cs-option-amt-left">
                        Price ({cartProductList?.length} items)
                      </div>
                      <div className="cs-option-amt-right">
                        {currencyCode} &nbsp;{calculateSubtotal()}
                      </div>
                    </div>
                    <div className="cs-option-amt-list cs-option-amt-listbg">
                      <div className="cs-option-amt-left">Sub Total</div>
                      <div className="cs-option-amt-right">
                        {currencyCode} &nbsp;{calculateTotalAmount()}
                      </div>
                    </div>
                    {/* Minimum Order Amount Info */}
                    {minimumOrderAmount > 0 && !isMinimumOrderMet && (
                      <div className="cs-option-amt-list text-info">
                        <div className="cs-option-amt-left">
                          <small>
                            Minimum order amount is {currencyCode} {minimumOrderAmount.toFixed(2)}
                          </small>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="price-footer">
                    <button
                      id="submit-btn"
                      className="continue-btn hover-btn center-block"
                      onClick={() => {
                        if (isLoggedIn) {
                          navigate(`${routes.checkout}`);
                        } else {
                          handleShowModal();
                        }
                      }}
                    >
                      Continue
                    </button>
                  </div>
                </div>
              ) : (
                <div className="text-center mt-5">
                  <p>Please Add Some Products to Cart</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Modal */}
      <Modal
        show={showModal}
        onHide={handleCloseModal}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Body>Please login to checkout the products</Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={handleCloseModal}>
            Close
          </button>
          <button
            className="btn btn-primary"
            onClick={() =>
              navigate(routes.login, { state: { from: routes.cart } })
            }
          >
            Login
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
